import { Component, forwardRef, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { FormControl } from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-rich-text-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxEditorModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichTextFieldComponent),
      multi: true
    }
  ],
  templateUrl: './rich-text-field.component.html',
  styleUrl: './rich-text-field.component.scss'
})
export class RichTextFieldComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() placeholder: string = 'Type here...';
  @Input() initialValue: string = '';
  @Output() valueChange = new EventEmitter<string>();
  @Input() maxLength: any;
  editor!: Editor;
  disabled = false;
  value: string = '';

  // Toolbar configuration
  @Input() toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify']
  ];

  ngOnInit(): void {
    this.editor = new Editor();
  }

  private onChangeFn: any = () => { };
  private onTouchedFn: any = () => { };

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  onChange(value: string) {
    this.value = value;
    if (this.maxLength) {
      const plainText = this.stripHtml(value || '');
      if (plainText.length > this.maxLength) {
        this.value = plainText.substring(0, this.maxLength);
      }
    }
    this.onChangeFn(value);
  }

  // Remove HTML tags to count only text characters
  private stripHtml(html: string): string {
    return html.replace(/<[^>]*>/g, '');
  }

  setDisabledState(isDisabled: boolean): void {
    // Optional: handle disabled state
    this.disabled = isDisabled;
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

}
